import React, { useState, useEffect } from 'react'
import { Card, Container } from 'react-bootstrap'
import { Form, Schema } from 'rsuite'
import FormActionButtons from '../../../../Shared/FormAction/FormActionButtons'
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Information from '../../../../Shared/Card/Information';
import { GetReinstatementInformationContent } from '../../../../Shared/InformationContent/PlsInformation';
import Swal from 'sweetalert2';
import reinstatementService from '../../../../../services/Internal/Reinstatement/reinstatement.service';
import Issues from '../../../../Shared/Card/Issues';
import entityService from '../../../../../services/Internal/Staff/entity.service';
import LoadingSpinner from '../../../../Shared/GenericComponents/LoadingSpinner';
import FormEntityInformation from '../../../Shared/FormEntityInformation';
import DocumentUpload from '../../../../Shared/Upload/DocumentUpload';

function QuizzesPage() {
    const appId = useSelector(x => x.currentApplicationId);
    const [hasLoaded, setHasLoaded] = useState(false);
    const sectionId = 4;
    const routes = useSelector(x => x.currentRoutes);
    const [hasFiles, setHasFiles] = useState(false);
    const [sectionData, setSectionData] = useState({});
    const [isComplete, setIsComplete] = useState(false);
    const [isUserEditable, setIsUserEditable] = useState(true);
    useEffect(() => {
        reinstatementService.plsGetSection(appId, sectionId).then((response) => {
            setSectionData(response.data)
            setIsComplete(response.data.staffReviewComplete)
            reinstatementService.getIndividualReinstatement(appId).then((data) => {
                setIsUserEditable(data.data.status.id == 2)
                entityService.getEntity(response.data.entityId).then((entity) => {
                    setEntityInfo(
                        {
                            ...entityInfo,
                            lolaNum: entity.data.lolaNumber,
                            entityName: entity.data.formattedName,
                            entityId: entity.data.entityId,
                            licenseNumber: data.data?.credential?.formattedLicenseNumber,
                            applicationDate: data.data?.dateSubmitted,
                            formType: data.data?.isOverFiveYears ? "Professional Land Surveyor Reinstatement (5 plus years)" : entityInfo.formType
                        })
                    setHasLoaded(true);
                });
            });
        })
    }, [])

    const push = useNavigate();
    const [entityInfo, setEntityInfo] = useState(
        {
            lolaNum: null,
            entityName: '',
            licenseNumber: '',
            formType: "Professional Land Surveyor Reinstatement",
            isIndividual: true,
            entityId: 0,
            applicationDate: "",
            currentSection: "Quizzes"
        }
    );

    const handleSave = () => {
        reinstatementService.plsMarkSectionComplete(appId, sectionId, isComplete).then((data) => {
            if (data.data)
                Swal.fire("Saved!")
        })
    }

    const handleSubmit = (val, event) => {
        if (!isUserEditable) {
            push(routes[routes.findIndex(el => { if (el.sectionId == sectionId) { return true; } }) + 1].route)
        }
        else if (hasFiles) {
            // do form post
            reinstatementService.plsMarkSectionComplete(appId, sectionId, isComplete).then((data) => {
                if (data.data)
                    push(routes[routes.findIndex(el => { if (el.sectionId == sectionId) { return true; } }) + 1].route)
            })
        }
    }

    return (
        <div>
            <Container fluid>
                <FormEntityInformation {...entityInfo} />
                <Information content={GetReinstatementInformationContent("quiz")} />
                <br />
                {hasLoaded ?
                    <Form onSubmit={handleSubmit} fluid> {/*This is to make sure validation is triggered and form does nothing else*/}
                        <Card>
                            <Card.Header>
                                <h6>Document Uploads</h6>
                            </Card.Header>
                            <Card.Body>
                                <DocumentUpload
                                    isUserEditable={isUserEditable}
                                    credentialTypeId={5}
                                    sectionId={sectionId}
                                    //appTypeId={appTypeId}
                                    //refreshData={ }
                                    parentId={sectionData.id}
                                    parentTypeId={2}
                                    entityId={entityInfo.entityId}
                                    setHasFiles={setHasFiles}
                                />
                                {!hasFiles && <div className="text-danger">Please select at least 1 file.</div>}
                            </Card.Body>
                        </Card>
                        <br />
                        <Issues isUserEditable={isUserEditable} isInternal={true} type={2} sectionId={sectionData.id} setIsComplete={setIsComplete} />
                        <FormActionButtons
                            isUserEditable={isUserEditable}
                            isComplete={isComplete}
                            isCompleteCallback={setIsComplete}
                            showSectionComplete={true}
                            handleSave={handleSave}
                            backToSectionLink="/internal/plsReinstatement/sections" />
                    </Form> : <LoadingSpinner />
                }

            </Container>
        </div>
    )
}
export default QuizzesPage;